import React, { useState } from "react";
import "./upload.css";
import axios from "axios";

const Upload = () => {
  const [upload, setUpload] = useState({ mediaTitle: "" });
  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState({ type: null, text: "" });
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const backendUrl = localStorage.getItem("basurl") + "/s3upload"; // Flask API URL

  const handleChange = (e) => {
    setUpload({ ...upload, [e.target.name]: e.target.value });
  };

  const resetMessage = () => {
    setMessage({ type: null, text: "" });
  };

  const getDateTime = () => {
    const date = new Date();
    return date.toISOString();
  };

  const formatSize = (bytes) => {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  const getFileName = (filename, mediatitle) => {
    let date = new Date().toISOString().split("T")[0];
    let sanitizedMediaTitle = mediatitle.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    let sanitizedFileName = filename.toLowerCase().replace(/[^a-z0-9.]+/g, "-");
    return `${date}-${user.firstname}-${sanitizedMediaTitle}-${sanitizedFileName}`;
  };

  const uploadFile = async (file, index) => {
    let formData = new FormData();
    let formattedFileName = getFileName(file.name, upload.mediaTitle);
    formData.append("file", file, formattedFileName);

    try {
      const response = await axios.post(backendUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "mojo-access-tokens": user.token,
        },
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setFiles((prevFiles) => {
            let updatedFiles = [...prevFiles];
            updatedFiles[index].percentage = percentCompleted;
            return updatedFiles;
          });
        },
      });

      let fileUrl = response.data.file_url;

      setFiles((prevFiles) => {
        let updatedFiles = [...prevFiles];
        updatedFiles[index].status = "Completed";
        updatedFiles[index].uploaded = true;
        updatedFiles[index].fileUrl = fileUrl;
        return updatedFiles;
      });

      setMessage({ type: "success", text: "File uploaded successfully!" });
      updateBackend(file, fileUrl);

    } catch (error) {
      setMessage({ type: "danger", text: error.response?.data?.error || "Upload failed" });
    }
  };

  const updateBackend = async (file, fileUrl) => {
    await axios.post(
      localStorage.getItem("basurl") + "/mediauploaded",
      {
        link: fileUrl,
        media_title: upload.mediaTitle,
        tracking: Date.now(),
        file_type: file.type,
        file_size: file.size,
        created_at: getDateTime(),
        updated_at: getDateTime(),
      },
      { headers: { "mojo-access-tokens": user.token } }
    );
  };

  const initProcess = (event) => {
    let selectedFiles = Array.from(event.target.files);
    let newFiles = selectedFiles.map((file) => ({
      id: Date.now() + Math.random(),
      name: getFileName(file.name, upload.mediaTitle),
      size: file.size,
      type: file.type,
      status: "Uploading...",
      uploaded: false,
      percentage: 0,
      formattedSize: formatSize(file.size),
    }));

    setFiles(newFiles);

    newFiles.forEach((file, index) => {
      uploadFile(selectedFiles[index], index);
    });
  };

  return (
    <>
      {message.type && (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong>{message.type === "success" ? "Success!" : "Error!"}</strong> {message.text}
        </div>
      )}

      <div id="filedropzone" className="mg-x-4 col-md-6">
        <input
          type="text"
          className="form-control mg-y-4"
          name="mediaTitle"
          placeholder="Enter media title"
          onFocus={resetMessage}
          onChange={handleChange}
        />
        <label className="custom-file">
          <input name="file" type="file" className="custom-file-input" onChange={initProcess} multiple accept="audio/*,video/*,image/*" />
          <span className="custom-file-control"></span>
        </label>
      </div>

      <section className="mg-4 tx-4">
        <ul className="UploadArea">
          {files.map((file) => (
            <li key={file.id} className={file.percentage >= 100 ? "success" : ""}>
              <fieldset>
                <legend>{file.name}</legend>
                {file.percentage < 100 ? (
                  <>
                    <div className="progress mg-b-10">
                      <div style={{ width: file.percentage + "%" }} className="progress-bar bg-success" role="progressbar">
                        {file.percentage} %
                      </div>
                    </div>
                    <small>{file.formattedSize}, {file.type}, {file.status} </small>
                  </>
                ) : (
                  <>
                    <small>{file.formattedSize}, {file.type}</small>
                    <div className="action">
                      <a href={file.fileUrl} target="_blank" rel="noopener noreferrer">View File</a>
                    </div>
                  </>
                )}
              </fieldset>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
};

export default Upload;
